import React from 'react';
import {
  Link, useWindowSize, Divider, Button, Box,
} from 'vindi-ds-components';
import Header from '@templates/header';

import { PrPlusSquare } from 'vindi-ds-icons/pr';

function HeaderProductList() {
  const { isMobile } = useWindowSize();

  return isMobile ? (
    <>
      <Header.Mobile
        links='/admin/configuration'
        title='Produtos'
      />
      <HeaderContent isMobile={isMobile} />
    </>
  ) : (
    <>
      <Header.Default
        links={[
          <Link href='/admin/configuration'>Configuração</Link>,
        ]}
        title='Produtos'
      />
      <HeaderContent isMobile={isMobile} />
    </>
  );
}

function HeaderContent({ isMobile }) {
  return (
    <>
      <Divider />
      <Box display='flex' my={3} justifyContent={{ md: 'end' }}>
        <Button
          href='products/new'
          startIcon={<PrPlusSquare size={16} />}
          fullWidth={!!isMobile}
        >
          Novo produto
        </Button>
      </Box>
    </>
  );
}

export default HeaderProductList;
